// olap-client/src/components/chat/DateSeparator.jsx
import React from 'react';

const DateSeparator = ({ title }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '16px 0',
      position: 'relative'
    }}>
      <div style={{
        background: 'rgba(0, 0, 0, 0.08)',
        color: '#ffffff',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '500',
        boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
      }}>
        {title}
      </div>
    </div>
  );
};

export default DateSeparator;